import React from "react";

import Tooltip from "@common/components/Tooltip/Tooltip";

import * as Styled from "./HorizontalBar.styles";

export interface HorizontalBarItem {
  key: string | number;
  percentage: number;
  color: string;
  tooltip: string;
}

export interface HorizontalBarProps {
  style?: React.CSSProperties;
  data: HorizontalBarItem[];
}

const HorizontalBar = ({ style, data }: HorizontalBarProps) => {
  const isEmpty = data.length === 0;

  if (isEmpty) {
    return (
      <Tooltip
        text={"No data"}
        position={"top"}
      >
        <Styled.HorizontalBar
          style={style}
          $isEmpty={isEmpty}
        />
      </Tooltip>
    );
  }
  return (
    <Styled.HorizontalBar style={style}>
      {data.map((segment, index) => (
        <Tooltip
          key={segment.key}
          text={segment.tooltip}
          position="top"
          style={{ flex: segment.percentage, width: "auto" }}
        >
          <Styled.HorizontalBarSegment
            $color={segment.color}
            $isFirst={index === 0}
            $isLast={index === data.length - 1}
          />
        </Tooltip>
      ))}
    </Styled.HorizontalBar>
  );
};

export default HorizontalBar;
